
import React, { useEffect, useRef } from 'react'
import './multichain.scss'
import { Link } from 'react-router-dom'
const Multichain = () => {
    return (
        <>
            <section className="multichainprnt">
                <div className="custom-container">
                    <div className="contentgateaway">
                        <div className="firstcardgateaway firstcardgateawayreverse">
                            <div className="leftcntgateaway">
                                <h6 >
                                    01
                                </h6>
                                <h3 >Smarter. Faster. Safer.</h3>
                                <p className='multichainpara'>AI-driven automation makes transactions seamless and secure.</p>
                                <div className="cryptocomandcnt">
                                    <p ><span>Error prevention –</span> AI ensures accuracy and reduces mistakes.</p>
                                    <p ><span>Context-aware commands –</span> Send crypto to contacts using just their name.</p>
                                    <p > <span>More AI features coming – </span> Identity verification, DeFi, NFTs & beyond.</p>
                                </div>

                            </div>
                            <div className="gateawayimg">
                                <img className='img-fluid' src="\assets\Wallet\safeimg.png" alt="secure Communication & Payments img" />
                            </div>
                        </div>
                        <div className="firstcardgateaway ">
                            <div className="gateawayimg">
                                <img className='img-fluid' src="\assets\Wallet\multichainimg.png" alt="Decentralized Groups Img" />
                            </div>
                            <div className="leftcntgateaway">
                                <h6 >
                                    02
                                </h6>
                                <h3 >Multi-Chain & Secure by Design</h3>
                                <p className='multichainpara'>TOMI Wallet is a self-custodial, multi-chain wallet built for security and control.</p>
                                <div className="cryptocomandcnt">
                                    <p ><span>Multi-Chain Support –</span> Ethereum, Bitcoin, Solana & more.</p>
                                    <p > <span>MEV Protection & Biometric Security –</span> Stay protected.</p>
                                </div>
                            </div>
                        </div>
                        <div className="firstcardgateaway firstcardgateawayreverse">
                            <div className="leftcntgateaway">
                                <h6 >
                                    03
                                </h6>
                                <h3 >Ready for the Future of Web3 </h3>
                                <p className='multichainpara'>Soon, TOMI Wallet will be part of the TOMI Super App, a complete Web3 ecosystem for finance, communication, and privacy.</p>
                                <div className="cryptocomandcnt">
                                    <p ><span>NFT & dApp Integration –</span> A seamless Web3 experience.</p>
                                    <p > <span>Expanding AI capabilities –</span> More automation, more control.</p>
                                </div>
                            </div>
                            <div className="gateawayimg">
                                <img className='img-fluid' src="\assets\Wallet\web3desktop.png" alt="Secure Browser & VPN img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Multichain